import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Flex } from '../../layout/Flex.mjs';
import { content } from '../datePicker.vanilla.mjs';

const DatePickerContent = ({
  children,
  className,
  ...rest
}) => {
  return /* @__PURE__ */ jsx(
    Flex,
    {
      direction: "column",
      align: "start",
      className: classNames(content, className),
      ...rest,
      children
    }
  );
};

export { DatePickerContent as default };
//# sourceMappingURL=Content.mjs.map
